import React, { useState, useEffect, useContext } from "react";
import { patientsService } from "../../services/patients";
import { Table } from "./components/Table";
import { useDebounce, useFetch } from "../../utils/hooks";
import styles from "../styles/Registers.module.css";
import { Heading } from "./components/Heading";
import { AddOrEditPatient } from "./components/AddOrEditPatient";
import { OrdinationsAndCountriesContext } from "../../contexts/ordinationsAndCountriesContext";

export const Patients = () => {
  const loadingSelectData = false;
  const [searchValue, setSearchValue] = useState("");
  const [orderValue, setOrderValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const size = localStorage.getItem("pageSizePatients")
    ? localStorage.getItem("pageSizePatients")
    : 20;
  const [pageSize, setPageSize] = useState(size);
  const [visiblePatientModal, setVisiblePatientModal] = useState(false);
  const debouncedSearchValue = useDebounce(searchValue);
  const { ordinationId } = useContext(OrdinationsAndCountriesContext);

  const loadPatients = (cancelToken) =>
    patientsService.getPatientsPaged({
      currentPage,
      pageSize,
      searchValue: debouncedSearchValue,
      cancelToken,
      orderValue,
    });

  const [
    {
      data: { results: patients, count: totalRows },
      isFetching,
    },
    getPatients,
  ] = useFetch(loadPatients);

  const loading = ordinationId === undefined || isFetching || loadingSelectData;

  useEffect(() => {
    setCurrentPage(1);
    setOrderValue("");
  }, [debouncedSearchValue]);

  useEffect(() => {
    getPatients();
  }, [
    debouncedSearchValue,
    pageSize,
    currentPage,
    getPatients,
    orderValue,
    ordinationId,
  ]);
  return (
    <div className={styles.registers}>
      <h1>Pacijenti</h1>

      <div //className={styles.medicalReportFormBoxes}
      >
        <Heading
          searchValue={searchValue}
          onSearch={(search) => setSearchValue(search)}
          onCreatePatientClicked={() => setVisiblePatientModal(true)}
        />
        <Table
          patients={patients}
          loading={loading}
          totalRows={totalRows}
          currentPage={currentPage}
          pageSize={pageSize}
          onClone={getPatients}
          onEdit={getPatients}
          onDelete={getPatients}
          orderValue={orderValue}
          setOrderValue={(order) => setOrderValue(order)}
          onPaginationChange={(page) => setCurrentPage(page)}
          onPageSizeChange={(size) => {
            setCurrentPage(1);
            setPageSize(size);
            localStorage.setItem("pageSizePatients", size);
          }}
        />
      </div>
      <AddOrEditPatient
        visibleModal={visiblePatientModal}
        onCloseModal={() => setVisiblePatientModal(false)}
        onAddPatient={getPatients}
      />
    </div>
  );
};
